import type { ButtonHTMLAttributes, ReactNode } from 'react'

export type VarianTombol = 'utama' | 'sekunder' | 'bahaya' | 'garis' | 'halus'
export type UkuranTombol = 'kecil' | 'sedang' | 'besar'

const KELAS_VARIAN: Record<VarianTombol, string> = {
  utama: 'bg-yayasan-700 text-white hover:bg-yayasan-800 border border-yayasan-700',
  sekunder: 'bg-netral-800 text-white hover:bg-netral-900 border border-netral-800',
  bahaya: 'bg-red-600 text-white hover:bg-red-700 border border-red-600',
  garis: 'bg-white text-netral-700 hover:bg-netral-100 border border-netral-300',
  halus: 'bg-transparent text-yayasan-800 hover:bg-yayasan-50 border border-transparent',
}

const KELAS_UKURAN: Record<UkuranTombol, string> = {
  kecil: 'px-2.5 py-1.5 text-xs',
  sedang: 'px-3.5 py-2 text-sm',
  besar: 'px-5 py-2.5 text-base',
}

export interface PropsTombol extends ButtonHTMLAttributes<HTMLButtonElement> {
  varian?: VarianTombol
  ukuran?: UkuranTombol
  memuat?: boolean
  ikon?: ReactNode
  lebarPenuh?: boolean
}

export function Button({
  varian = 'utama',
  ukuran = 'sedang',
  memuat = false,
  ikon,
  lebarPenuh = false,
  className = '',
  disabled,
  children,
  ...sisa
}: PropsTombol) {
  return (
    <button
      type={sisa.type ?? 'button'}
      disabled={disabled || memuat}
      className={`inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
        KELAS_VARIAN[varian]
      } ${KELAS_UKURAN[ukuran]} ${lebarPenuh ? 'w-full' : ''} ${className}`}
      {...sisa}
    >
      {memuat ? (
        <span
          aria-hidden="true"
          className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-current border-t-transparent"
        />
      ) : (
        ikon
      )}
      <span>{children}</span>
    </button>
  )
}
